<template>
  <b-form @submit.prevent="onSubmit" novalidate>
    <b-form-group label-for="input-team-name">
      <template #label>
        How would you like to call your team?*
      </template>
      <b-form-input id="input-team-name" v-model="form.name" :state="isValidField('name')" placeholder="eg., Ericka" class="rounded-pill" />
      <b-form-invalid-feedback :state="isValidField('name')">
        <div v-for="error in errors.name || []" :key="error">
          {{ error }}
        </div>
      </b-form-invalid-feedback>
    </b-form-group>
    <b-form-row class="mt-5">
      <b-col>
        <b-button :disabled="submitting" pill variant="outline-primary" class="pl-5 pr-5" @click.prevent="$emit('back')">Back</b-button>
      </b-col>
      <b-col cols="auto">
        <b-button type="submit" :disabled="submitting" pill variant="primary" class="pl-5 pr-5">Next</b-button>
      </b-col>
    </b-form-row>
  </b-form>
</template>

<script>
import validator from 'validator'
import MixinForm from '../MixinForm'

export default {
  name: 'TeamProfileForm',

  mixins: [MixinForm],

  data() {
    return {
      form: {
        name: ''
      }
    }
  },

  methods: {
    validate(data) {
      const errors = {}
      if (validator.isEmpty(data.name || '')) errors.name = ["First name can't be blank"]
      return errors
    }
  }
}
</script>
